<template>
  <div class="row">
    <div class="col text-center pt-5 pb-5">
      <img src="/images/main_loader.gif" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: "mainLoader",
}
</script>